import React, { Component } from 'react';
import { lit } from '../../../utils/literal.js';
import Style from './angle.less.js';

/**
 * @public
 * @deprecated
 * AngleCircle 组件会移入 DUI，2.0 版本后，Form 扩展不再通过枚举提供此变量
 */
const DragAngleCircleType = {
    START: lit('start'),
    DRAGGING: lit('dragging'),
    STOP: lit('stop'),
};
/**
 * 计算两条相交线段之间的夹角
 * 返回角度值
 */
function getAngleForTwoLine({ x: x1, y: y1 }, { x: x2, y: y2 }) {
    const dot = (x1 * x2) + (y1 * y2);
    const det = (x1 * y2) - (y1 * x2);
    const angle = Math.atan2(det, dot) / Math.PI * 180;
    return Math.round((angle + 360) % 360);
}
const CIRCLE_OUTER_SIZE = 26;
const CIRCLE_MINI_SIZE = 6;
const BORDER_WIDTH = 1;
/**
 * 公用组件，圆中拖拽计算角度
 */
class DragAngleCircle extends Component {
    constructor(props) {
        super(props);
        this.addDragListener = () => {
            document.addEventListener('mousemove', this.handleDragging);
            document.addEventListener('mouseup', this.handleDragStop);
        };
        this.removeDragListener = () => {
            document.removeEventListener('mousemove', this.handleDragging);
            document.removeEventListener('mouseup', this.handleDragStop);
        };
        this.handleDragStart = (e) => {
            const activeEle = document.activeElement;
            if ((activeEle === null || activeEle === void 0 ? void 0 : activeEle.tagName) && activeEle.tagName.toLowerCase() !== 'input') {
                e.preventDefault();
            }
            if (e.currentTarget) {
                this.addDragListener();
                const rect = e.currentTarget.getBoundingClientRect();
                this.dragObj = {
                    rect,
                    isDragging: false,
                    clientX: e.clientX,
                    clientY: e.clientY,
                };
            }
            this.changeAngle(null, DragAngleCircleType.START);
        };
        this.handleDragging = (e) => {
            if (this.dragObj.clientX === e.clientX && this.dragObj.clientY === e.clientY) {
                // 坐标无变更
                this.dragObj.clientX = null;
                this.dragObj.clientY = null;
            }
            else {
                this.dragObj.isDragging = true;
                const { rect } = this.dragObj;
                const endPoint = { x: e.clientX - rect.left - this.cx, y: e.clientY - rect.top - this.cy };
                this.changeAngle(endPoint, DragAngleCircleType.DRAGGING);
            }
        };
        this.handleDragStop = (e) => {
            this.dragObj.isDragging = false;
            this.removeDragListener();
            const { rect } = this.dragObj;
            const endPoint = { x: e.clientX - rect.left - this.cx, y: e.clientY - rect.top - this.cy };
            this.changeAngle(endPoint, DragAngleCircleType.STOP);
        };
        this.changeAngle = (endPoint, dragState) => {
            var _a, _b, _c, _d;
            if (endPoint) {
                let angle = getAngleForTwoLine(this.startPoint, endPoint);
                this.updateSmallCircleLoc(angle);
                if (angle === 360) {
                    angle = 0;
                }
                (_b = (_a = this.props).onAngleChange) === null || _b === void 0 ? void 0 : _b.call(_a, `${angle}°`, dragState);
            }
            else {
                (_d = (_c = this.props).onAngleChange) === null || _d === void 0 ? void 0 : _d.call(_c, this.props.angle, dragState);
            }
        };
        // 计算小圆的坐标
        this.updateSmallCircleLoc = (angle) => {
            const radian = angle * Math.PI / 180; // 弧度
            const x = Math.cos(radian) * this.r;
            const y = Math.sin(radian) * this.r;
            const minW = Math.cos(radian) * this.minR;
            const minH = Math.sin(radian) * this.minR;
            const minX = Math.round(x - minW - this.minR);
            const minY = Math.round(y - minH - this.minR);
            this.setState({
                left: minX + this.cx,
                top: minY + this.cy,
            });
        };
        this.state = {
            left: 0,
            top: CIRCLE_MINI_SIZE + 1,
        };
        // 圆心和半径
        this.cx = (CIRCLE_OUTER_SIZE - (BORDER_WIDTH * 0)) / 2;
        this.cy = this.cx;
        this.r = this.cx;
        this.minR = CIRCLE_MINI_SIZE / 2;
        this.startPoint = { x: this.cx, y: 0 };
    }
    componentDidMount() {
        let angle = typeof (this.props.angle) === 'undefined' ? 0 : this.props.angle;
        if (angle > 360) {
            angle = angle % 360;
        }
        this.updateSmallCircleLoc(angle);
    }
    componentWillReceiveProps(nextProps) {
        let angle = typeof (nextProps.angle) === 'undefined' ? 0 : nextProps.angle;
        if (angle > 360) {
            angle = angle % 360;
        }
        this.updateSmallCircleLoc(angle);
    }
    render() {
        const outerCircleStyle = { width: CIRCLE_OUTER_SIZE, height: CIRCLE_OUTER_SIZE, borderWidth: BORDER_WIDTH };
        const smallCircleStyle = {
            left: this.state.left, top: this.state.top, width: CIRCLE_MINI_SIZE, height: CIRCLE_MINI_SIZE,
        };
        return (React.createElement("div", { className: Style['circle-big'], style: outerCircleStyle, onMouseDown: this.handleDragStart },
            React.createElement("div", { className: Style['circle-small'], style: smallCircleStyle })));
    }
}

export { DragAngleCircleType, DragAngleCircle as default, getAngleForTwoLine };
//# sourceMappingURL=angle-circle.js.map
